<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('表编号')">
              <a-input :placeholder="$t('请输入表编号')" v-model="queryParam.meterId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户编号')">
              <a-input :placeholder="$t('请输入用户编号')" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
    </div>
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="showMeterCommandQueue(record)">{{ $t('命令队列') }}</a>
          <a-divider type="vertical" />
          <!--
          <a @click="debuggingCommands(record)">{{ $t('命令下发') }}</a>
          <a-divider type="vertical" />
          -->
          <a @click="debugNewCommand(record)">{{ $t('新协议命令下发') }}</a>
        </span>
      </a-table>
    </div>
    <meter-debuggingCommands-modal ref="debuggingCommandsModal" @ok="debuggingCommandsFormOk"></meter-debuggingCommands-modal>
    <debug-newCommand-modal ref="debugNewCommandModal" @ok="debuggingCommandsFormOk"></debug-newCommand-modal>
    <meter-command-queue-modal ref="metrCommandQueueModal" @ok="debuggingCommandsFormOk"></meter-command-queue-modal>
  </a-card>
</template>
<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import MeterDebuggingCommandsModal from './modules/MeterDebuggingCommandsModal'
  import debugNewCommandModal from './modules/debugNewCommandModal'
  import meterCommandQueueModal from './modules/meterCommandQueueModal'
  import { listSize } from '@/utils/util'
  import { getAction } from '@/api/manage'
  export default {
    name: 'MeterDebuggingCommandsList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      MeterDebuggingCommandsModal,
      debugNewCommandModal,
      meterCommandQueueModal
    },
    data () {
      return {
        description: 'meter_userinfo管理页面',
        url: {
          list: "/model/partMeter/list",
          exportXlsUrl: "/jeecg-charge/meter/meterUserinfo/exportXls",
        }
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t, r, index) => {
              return parseInt(index)+1;
            }
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId'
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr'
          },{
            title: this.$t('表安装地址'),
            align:"center",
            dataIndex: 'userMeterAddr'
          },{
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },{
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      debuggingCommands(record) {
        this.$refs.debuggingCommandsModal.edit(record)
        this.$refs.debuggingCommandsModal.title = this.$t('命令下发')
        // this.queryUserTypeList(record)
      },
      // 新协议远程命令下发
      debugNewCommand(record) {
        this.$refs.debugNewCommandModal.edit(record)
      },
      debuggingCommandsFormOk() {
        this.loadData();
      },
      showMeterCommandQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record)
      },
      showMeterCommandOldQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>